<!--
 * @Author: your name
 * @Date: 2020-11-05 10:56:35
 * @LastEditTime: 2021-03-04 09:37:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\components\index\swiper.vue
-->
<template>
<div >
   <swiper :options="swiperOption"  >
        <swiper-slide 
           class="swiper-slide" 
           v-for="banImg of swiperBanner"
           :key="banImg.id"
           v-cloak 
        >
          <!-- <el-image :src="banImg.image"></el-image> -->
          <img :src="banImg.image" alt="">
        </swiper-slide>
    </swiper>
        <!-- 左右箭头 --> 
        <div class="swiper-button-prev" slot="button-prev"><img src="./../../assets/image/btn_left.png" alt=""></div> 
        <div class="swiper-button-next" slot="button-next"> <img src="./../../assets/image/btn_right.png" alt=""></div> 
 </div>
</template>

<script>
let vm = null;
export default {
    props: ['swiperBanner'],
     data(){
        return {
            swiperOption:{
                //显示分页
                pagination: {
                     el: '.swiper-pagination',
                     clickable :true,     //点击分页切换
                },
                loop: true,           //开启循环模式
                autoplay: {   //自动切换的时间
                    delay: 3000,
                    disableOnInteraction: false,   //自动切换不会停止
                },
                //设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next', 
                    prevEl: '.swiper-button-prev'
                },
                initialSlide :1,        //默认显示第一页 
                preventClicksPropagation : true,
                    on:{
                        click (){
                            const realIndex = (this.activeIndex - 1 + vm.swiperBanner.length) % (vm.swiperBanner.length);
                             vm.handleClickSlide(vm.swiperBanner[realIndex])
                        },
                    },
            }
        }
  },
   created() {
        vm = this;
    },
    methods: {
         /**
         * @description: 跳转指定页面
         * @param {Object} info
         */   
        handleClickSlide(info) {
           const routeUrl = this.$router.resolve({
                path: info.url, 
                query: {
                    num: 2,
                    lang: this.$route.query.lang
                }
            })
            const url = routeUrl.href.substring(1)
            window.open(url ,'_blank') 
        },

    }
}
</script>

<style scoped lang="scss">
 [v-cloak] {
        display: none;
    }
    
>>> .swiper-container {
    height: 480px;
    // background-color: #f1f1f1;
}
>>> .swiper-slide{
  height: 480px;
  img{
    width: 1920px;
    height: 480px;
    cursor: pointer;
  }
}
.swiper-button-prev:after, .swiper-button-next:after {
    display: none;
}
.swiper-button-prev {
    left:5%;
    top: 290px;
}
.swiper-button-next {
    right: 5%;
    top: 290px;
    z-index: 111;
}
:focus{
    outline:none;
}
</style>


// WEBPACK FOOTER //
// src/components/index/swiper.vue